export default function getBuildFormUrlencodedParams(data: any): string {
  const entries = Object.entries(data);
  let params = '';
  entries.forEach(([key, value]) => {
    params += `${key}=${value}&`;
  });

  return params.slice(0, -1);
}
